export default __webpack_public_path__ + "static/media/map_fuji.518b9ce3.gif";